// routes/PlotRoute.jsx
import React from 'react';
import PlotSite from '../pages/Plot';
import { useUser } from '../contexts/UserContext';

function PlotRoute() {
  const { user } = useUser();
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  return (
    <PlotSite
      backendUrl={backendUrl}
      user={user}
    />
  );
}

export default PlotRoute;
